<main class="table-page table-page--fill" dir="rtl">
  <header class="header">
    <div class="title-row">
      <button class="back" type="button" title="بازگشت" aria-label="بازگشت" (click)="goBack()">
        <i class="fa fa-arrow-right"></i>
      </button>
      <div class="title-block">
        <h1 class="title">{{ definition.title }}</h1>
        <span class="muted">{{ subtitle | faNum }}</span>
      </div>
      <div class="actions">
        <button class="btn btn-ghost" id="filterToggle" type="button" [disabled]="loading"
          [attr.aria-expanded]="filtersOpen" aria-controls="busFiltersWrap" (click)="toggleFilters()">
          <i class="fa fa-sliders"></i> فیلتر
          <span class="badge" [class.show]="filterCount > 0">{{ filterCount | faNum }}</span>
          <i class="fa fa-chevron-down chev"></i>
        </button>
      </div>
    </div>

    <div class="collapsible" id="busFiltersWrap" [class.collapsed]="!filtersOpen">
      <div class="collapsible-inner">
        <form class="filters" [formGroup]="filterForm" (ngSubmit)="loadReport()">
          <label class="field" *ngIf="isBusPresence">
            <span class="field-label">اتوبوس</span>
            <select class="control" formControlName="bus">
              <option value="">انتخاب اتوبوس</option>
              <option *ngFor="let bus of buses" [value]="bus.strUnitID">{{ bus.strFullName | faNum }}</option>
            </select>
          </label>
          <label class="field" *ngIf="!isBusPresence">
            <span class="field-label">خط</span>
            <select class="control" formControlName="line" (change)="onLineChange()">
              <option value="">انتخاب خط</option>
              <option *ngFor="let line of lines" [value]="line.iBusLine">{{ line.strBusLineName | faNum }}</option>
            </select>
          </label>
          <label class="field" *ngIf="!isBusPresence">
            <span class="field-label">ایستگاه</span>
            <select class="control" formControlName="stop">
              <option value="">انتخاب ایستگاه</option>
              <option *ngFor="let stop of stops" [value]="stop.iBusStop">{{ stop.strBusStopName | faNum }}</option>
            </select>
          </label>
          <div class="field">
            <span class="field-label">{{ isBusPresence ? 'تاریخ' : 'از تاریخ' }}</span>
            <ng-persian-datepicker [uiTheme]="'gray'" [dateInitValue]="false" [timeEnable]="false"
              [uiHideAfterSelectDate]="true" [uiHideOnOutsideClick]="true"
              [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
              <input class="control" type="text" formControlName="startDate" readonly>
            </ng-persian-datepicker>
          </div>
          <div class="field" *ngIf="!isBusPresence">
            <span class="field-label">تا تاریخ</span>
            <ng-persian-datepicker [uiTheme]="'gray'" [dateInitValue]="false" [timeEnable]="false"
              [uiHideAfterSelectDate]="true" [uiHideOnOutsideClick]="true"
              [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
              <input class="control" type="text" formControlName="endDate" readonly>
            </ng-persian-datepicker>
          </div>
          <div class="filter-actions">
            <button class="btn btn-primary" type="submit" [disabled]="loading || !canLoadReport">
              <i class="fa fa-search"></i> بررسی گزارش
            </button>
          </div>
        </form>
      </div>
    </div>
  </header>

  <section class="card">
    <div class="table-toolbar">
      <label class="search-wrap">
        <input class="control" type="search" [(ngModel)]="searchText" (ngModelChange)="onSearchChange()"
          [placeholder]="searchPlaceholder" [disabled]="loading">
        <i class="fa fa-search"></i>
      </label>
      <div class="toolbar-actions">
        <button class="btn btn-soft" type="button" [disabled]="loading || hasError || !filteredRows.length"
          [useExistingCss]="true" ngxPrint [printTitle]="definition.title" [printSectionId]="printSectionId">
          <i class="fa fa-print"></i> چاپ
        </button>
        <button class="btn btn-soft" type="button" [disabled]="loading || hasError || !filteredRows.length" (click)="exportExcel()">
          <i class="fa fa-file-excel-o"></i> خروجی اکسل
        </button>
      </div>
    </div>

    <div class="body">
      <div class="loader" [class.show]="loading" role="status" aria-live="polite">
        <div class="spinner"></div><span>در حال دریافت اطلاعات…</span>
      </div>
      <div class="state" id="stEmpty" [class.show]="!loading && !hasError && !filteredRows.length">
        <div class="ico-big"><i class="fa fa-inbox"></i></div>
        <h4>{{ emptyTitle }}</h4>
        <span class="muted">{{ emptyDescription }}</span>
        <div class="empty-actions" *ngIf="hasActiveFilters">
          <button class="btn btn-primary" type="button" (click)="clearSearch()"><i class="fa fa-undo"></i> حذف فیلترها</button>
        </div>
      </div>
      <div class="state error" id="stError" [class.show]="!loading && hasError">
        <div class="ico-big"><i class="fa fa-exclamation-triangle"></i></div>
        <h4>دریافت اطلاعات با خطا مواجه شد</h4>
        <span class="muted">اتصال به سرور را بررسی و دوباره تلاش کنید.</span>
        <button class="btn btn-primary retry" type="button" [disabled]="loading" (click)="retry()">
          <i class="fa fa-refresh"></i> تلاش مجدد
        </button>
      </div>
      <div class="table-scroll" id="tableWrap" *ngIf="!loading && !hasError && filteredRows.length">
        <ng-container [ngTemplateOutlet]="reportTable"
          [ngTemplateOutletContext]="{ tableRows: pagedRows, offset: (currentPage - 1) * pageSize }"></ng-container>
      </div>
    </div>
    <app-table-pagination [page]="currentPage" [pageSize]="pageSize" [totalItems]="filteredRows.length"
      [pageSizeOptions]="pageSizeOptions" (pageChange)="goToPage($event)" (pageSizeChange)="onPageSizeChange($event)">
    </app-table-pagination>
  </section>

  <div class="print-only" [id]="printSectionId" *ngIf="!loading && !hasError && filteredRows.length">
    <div class="table-page" dir="rtl">
      <h1 class="title">{{ definition.title }}</h1>
      <span class="muted">{{ subtitle | faNum }}</span>
      <ng-container [ngTemplateOutlet]="reportTable"
        [ngTemplateOutletContext]="{ tableRows: filteredRows, offset: 0, printing: true }"></ng-container>
    </div>
  </div>

  <ng-template #reportTable let-tableRows="tableRows" let-offset="offset" let-printing="printing">
    <table [id]="printing ? null : tableId">
      <thead>
        <tr><th class="col-num">#</th><th *ngFor="let column of columns">{{ column.title }}</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of tableRows; let index = index">
          <td class="col-num">{{ offset + index + 1 | faNum }}</td>
          <td *ngFor="let column of columns">{{ cellValue(row, column) | faNum }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr><td class="label" [attr.colspan]="columns.length + 1">تعداد کل: <span>{{ filteredRows.length | number | faNum }}</span></td></tr>
      </tfoot>
    </table>
  </ng-template>
</main>
